import React, { useState } from "react";
import {
  Select,
  Message,
  TextArea,
  InputField,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { FOLDERS } from "../doseeData/utils/Utils";
import { codeOk, errorMessage } from "../../lib/index";
import { useBannerContext } from "../../context/BannerContext";
import { getOneBanner } from "../../lib/sysNavigation/SysNavigation";
import { defaultImage } from "../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../ui/ImageKitLibrary";
import { FiImage, FiAlignLeft, FiSettings } from "react-icons/fi";

const Edit = () => {
  const { updateBannerState, updateBanner } = useBannerContext();
  const banner = getOneBanner();
  const banner_id = banner?.banner_id;
  const [error, setError] = useState(false);
  const [status, setStatus] = useState(0);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [type, setType] = useState(banner?.type);
  const [message, setErrorMessage] = useState("");
  const [title, setTitle] = useState(banner?.title);
  const [thumbnail, setThumbnail] = useState(banner?.thumbnail);
  const [bannerStatus, setEventStatus] = useState(banner?.status);
  const [description, setDescription] = useState(banner?.description);
  const [thumbnailId, setThumbnailId] = useState(banner?.image_cdn_id);
  const bannerRoutes = "/banner";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
  };

  const responses = (isError: any, st: any, msg: any) => {
    setError(isError);
    setStatus(st);
    setErrorMessage(msg);
  };

  const updateOneBannerHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      setLoading(false);
      return responses(true, 400, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      title: title,
      description: description,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      status: bannerStatus,
      type: type,
    };

    const response = await updateBanner(banner_id, data);
    if (response) {
      if (response.data.status === codeOk) {
        updateBannerState({ banner_id, ...data });
        cleanFields();
        return responses(true, response.data.status, response.data.message);
      } else {
        setLoading(false);
        return responses(true, response.data.status, response.data.message);
      }
    } else {
      setLoading(false);
      return responses(true, 400, errorMessage);
    }
  };

  return (
    <AddPageShell
      backRoute={bannerRoutes}
      eyebrow="Marketing • Banners"
      title="Edit Banner"
      subtitle="Update the banner image, target page, and short description."
      icon={<FiImage className="h-5 w-5" />}
      pills={[
        { label: "Page", value: type || "—" },
        { label: "Status", value: bannerStatus === 1 ? "Visible" : "Hidden" },
      ]}
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneBannerHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage("");
      }}
      message={
        <Message
          props={{
            error,
            success,
            message,
            loading,
            status,
            onClick: () => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            },
          }}
        />
      }
    >
      <AddSection
        title="Banner Image"
        hint="1600×600 recommended. JPG or PNG."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={FOLDERS.BANNER}
        />
      </AddSection>

      <AddSection
        title="Placement & Status"
        hint="Choose the target page and whether the banner should be visible."
        icon={<FiSettings className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Name",
              type: "text",
              value: title ? title : "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <Select
            props={{
              id: "type",
              title: "Page",
              option: [
                "home",
                "about",
                "tour",
                "market",
                "contact",
                "attraction",
                "best",
                "cities",
                "countries",
                "events",
                "hotels",
                "parties",
                "safaris",
                "timeframe events",
              ],
              preselect:
                type !== null && type !== undefined ? [{ name: type }] : null,
              onChange: (e: any) => {
                setType(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <Select
            props={{
              id: "banner_status",
              title: "Status",
              option: ["visible", "invisible"],
              preselect:
                bannerStatus !== null && bannerStatus !== undefined
                  ? [{ name: bannerStatus === 1 ? "visible" : "invisible" }]
                  : null,
              onChange: (e: any) => {
                if (e.target.selectedIndex === 0) setEventStatus(1);
                else setEventStatus(0);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Description"
        hint="Keep it short — a single sentence works best."
        icon={<FiAlignLeft className="h-4 w-4" />}
      >
        <TextArea
          props={{
            id: "description",
            title: "Description",
            type: "text",
            value: description ? description : "",
            onChange: (e: any) => {
              setDescription(e.target.value);
              setError(null);
              setSuccess(null);
            },
          }}
        />
      </AddSection>
    </AddPageShell>
  );
};

export default Edit;
